/** @typedef {import('../models/photo-entity').default} PhotoEntity */

import { PHOTO_TIME, PHOTO_TIME_NUM } from "../constants"

function formatDateTime(timestamp) {
  return new Date(timestamp).toLocaleString("en-US", {
    hours12: true,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export default class TimestampElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof TimestampElement
   */
  static fromHtmlElement(htmlElement) {
    return new TimestampElement(
      htmlElement.querySelector(PHOTO_TIME),
      htmlElement.querySelector(PHOTO_TIME_NUM),
    )
  }

  /**
   * Creates an instance of TimestampElement.
   * @param {HTMLElement} root
   * @param {HTMLElement} timestampElement
   * @memberof TimestampElement
   */
  constructor(root, timestampElement) {
    this.root = root
    this.timestampElement = timestampElement
  }

  /**
   * @param {PhotoEntity} photo
   * @memberof TimestampElement
   */
  apply(photo) {
    this.root.classList.toggle("is-hidden", photo.timestamp === null)

    if (photo.timestamp !== null) {
      this.timestampElement.dataset.date = photo.timestamp
      this.timestampElement.textContent = formatDateTime(photo.timestamp)
    }
  }
}
